import { takeEvery, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as authSaga from "../sagas/authSaga";

export function* rootSaga() {
	// Example
	yield takeLatest(actionTypes.LOGOUT, authSaga.logout);
	yield takeEvery(actionTypes.LOGIN_SUCCEED_SAGA, authSaga.loginSucceed);
	yield takeLatest(actionTypes.FETCH_FAVORITES, authSaga.fetchFavorites);
	yield takeLatest(actionTypes.ADD_REMOVE_FAVORITE, authSaga.addRemoveFavorite);
}
